export const WalletType = Object.freeze({
  'Card': 'card',
  'Wallet': 'wallet',
})
